import { GetStaticProps } from 'next';

import CategoryPage, {
  getCategoryStaticProps,
} from '@/components/layout/ProductCategory';

export default CategoryPage;

export const getStaticProps: GetStaticProps = async (context) => {
  return await getCategoryStaticProps('sheet-metal', context.locale);
};
